import React, { useEffect, useState } from "react";
import { FiSend } from "react-icons/fi";
import emailjs from "emailjs-com";
import "./Form.scss";

const Form = () => {
    const [isSend, setIsSend] = useState(false);
    const [flag, setFlag] = useState(false)

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')

    useEffect(() => {
        setTimeout(() => {
            setIsSend(false);
        }, 2000);
    }, [isSend]);

    const sendEmail = (e) => {
        e.preventDefault();

        if(name && email && message){
            emailjs
            .sendForm(
                "service_eipkivk",
                "template_hlhm3mm",
                e.target,
                "user_skNDqLjo2feSzlpcC1t7z"
            )
            .then(
                (result) => {
                    // console.log(result.text);
                    setName('')
                    setEmail('')
                    setMessage('')
                    setFlag(false)
                    setIsSend(true);
                },
                (error) => {
                    // console.log(error.text);
                    setIsSend(false);
                }
            );
            
        e.target.reset();
        }else{
            setFlag(true)
        }
        
    };

    return (
        <form className="form" onSubmit={sendEmail}>
            {isSend && <p ><small>message send successfully.</small></p>}
            {flag && <p className="red-text"><small>Some inputs are missing.</small></p>}
            <label>NAME</label>
            <input type="text" name="name" value={name} onChange={e=>setName(e.target.name)} />
            <label>EMAIL</label>
            <input type="text" name="email" value={email} onChange={e=>setEmail(e.target.value)} />
            <label>MESSAGE</label>
            <textarea type="text" rows="5" name="message"  value={message} onChange={e=>setMessage(e.target.value)} ></textarea>
            <button>
                <span>send</span>
                <FiSend />
            </button>
        </form>
    );
};

export default Form;
